'use client';
import React, { useState } from 'react';
interface IDownload {
  link: string;
  text?: string;
  className?: string;
  filename: string;
  children?: React.ReactNode;
}
export const Download = (props: IDownload) => {
  const { link, text, className, filename, children } = props;
  const [loading, setLoading] = useState(false);
  const handleDownload = async () => {
    setLoading(true);
    if (loading) return;
    const response = await fetch(link);
    const blob = await response.blob();

    // 创建一个隐藏的 <a> 元素
    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    // 将 Blob 转换为 URL 并设置为 <a> 的 href 属性
    a.href = URL.createObjectURL(blob);
    a.download = filename;

    // 模拟点击事件以触发下载
    a.click();
    setLoading(false);

    // 清理
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  };
  return children ? (
    <div className={className} onClick={handleDownload}>
      {children}
    </div>
  ) : (
    <span className={className} onClick={handleDownload}>
      {text} {loading && <Loading />}
      {/* <span className="rounded-full w-2 h-2 ml-1 inline-block border-blue-400 border-2 " /> */}
    </span>
  );
};

const Loading = () => (
  <span className="rounded-full w-3 h-3 ml-1 inline-block border-blue-400 border-[1px] border-b-0 animate-spin" />
);
